// extracted by mini-css-extract-plugin
module.exports = {"content":"FormDescription_content__pUaeU","counter":"FormDescription_counter__1OASe","fadeIn":"FormDescription_fadeIn__1Mrjn","fadeOut":"FormDescription_fadeOut__2D5e0"};